import React from 'react';
import LazyMetrics from '../../dashboard-year/LazyMetrics';
import EducatorsWithOpenProjectGroup from '../../dashboard-year/Goals/EducatorsWithOpenProject';
import EducatorsWithCompletedProjectGroup from '../../dashboard-year/Goals/EducatorsWithCompletedProject';
import EducatorEvaluationsCompletedGroup from '../../dashboard-year/Goals/EducatorEvaluationsCompleted';
import PartnerInvitationsWithResponseGroup from '../../dashboard-year/Goals/PartnerInvitationsWithResponse';
import PartnersEngagingWithEducatorsGroup from '../../dashboard-year/Goals/PartnersEngagingWithEducators';

export default function Partners(props) {
  const { params } = props;

  return (
    <>
      <LazyMetrics
        title="% of educators who shared a project"
        columns={3}
      >
        <EducatorsWithOpenProjectGroup {...params} titleOnly={true} />
      </LazyMetrics>
      <LazyMetrics
        title="% of educators with a completed project"
        columns={3}
      >
        <EducatorsWithCompletedProjectGroup {...params} titleOnly={true} />
      </LazyMetrics>
      <LazyMetrics
        title="% of educator evaluations completed"
        columns={3}
      >
        <EducatorEvaluationsCompletedGroup {...params} titleOnly={true} />
      </LazyMetrics>
      <LazyMetrics
        title="% invitations responded to by a partner"
        columns={3}
      >
        <PartnerInvitationsWithResponseGroup {...params} titleOnly={true} />
      </LazyMetrics>
      <LazyMetrics
        title="% partners engaging with educators"
        columns={3}
      >
        <PartnersEngagingWithEducatorsGroup {...params} titleOnly={true} />
      </LazyMetrics>
    </>
  );
}
